import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AcessoAPIService {

  private baseUrl = `${environment.APIEndpoint}acesso`;

  constructor(private http: HttpClient) { }

  getAcesso(usuarioId: number, recursoId: string) {
    return this.http.get(this.baseUrl + `/${usuarioId}/recurso/${recursoId}`);
  }    

  getAllAcesso(usuarioId: number) {
    return this.http.get(this.baseUrl + `/${usuarioId}/recurso`);
  }    
}
